import React from 'react'

import { HStack, Icon, T, VStack } from 'govwell-ui'

import ContentAreaOverlay from 'src/components/ContentAreaOverlay/ContentAreaOverlay'
import { useStaffAIAssistant } from 'src/components/StaffAIAssistant/StaffAIAssistantContext'
import { useIsInternalStaffAIEnabled } from 'src/utils/featureFlagging/featureFlagging'

const StaffAIAssistantOverlayContent = ({ onClose }: { onClose: () => void }) => {
  return (
    <>
      {/* Header */}
      <HStack className="justify-between border-b border-neutral-200 px-6 py-4 dark:border-neutral-700">
        <HStack gap={3}>
          <Icon.FaSparkles className="h-5 w-5 text-orange-500" />
          <T.H4 className="m-0 font-semibold">AI Assistant</T.H4>
        </HStack>
        <button
          type="button"
          onClick={onClose}
          className="flex cursor-pointer items-center justify-center rounded-lg p-2 text-neutral-600 hover:bg-neutral-100 dark:text-neutral-400 dark:hover:bg-neutral-800"
          aria-label="Close"
        >
          <Icon.FaXmark className="h-5 w-5" />
        </button>
      </HStack>

      {/* Content */}
      <div className="flex flex-1 flex-col overflow-auto">
        <VStack className="flex-1 items-center justify-center py-16">
          <div className="rounded-full bg-purple-100 p-6 dark:bg-purple-900">
            <Icon.FaSparkles className="h-12 w-12 text-purple-600 dark:text-purple-400" />
          </div>
          <T.H3 className="mt-4">Staff AI Assistant</T.H3>
          <T.Body className="max-w-md text-center text-neutral-600 dark:text-neutral-400">
            Coming soon! This is where you&apos;ll be able to ask questions and get AI-powered
            assistance with your GovWell workflow.
          </T.Body>
        </VStack>
      </div>
    </>
  )
}

const StaffAIAssistantOverlay = () => {
  const isInternalStaffAIEnabled = useIsInternalStaffAIEnabled()
  const modalState = useStaffAIAssistant()

  // Guard: feature flag must be enabled and context must be available
  if (!isInternalStaffAIEnabled || !modalState) {
    return null
  }

  return (
    <ContentAreaOverlay isOpen={modalState.isOpen} onClose={modalState.close}>
      <StaffAIAssistantOverlayContent onClose={modalState.close} />
    </ContentAreaOverlay>
  )
}

export default React.memo(StaffAIAssistantOverlay)
